import "./Typer.css";
import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import React, { useEffect } from "react";

gsap.registerPlugin(ScrollTrigger);
const TypingText = () => {
  gsap.utils.toArray(".list-item").forEach((item, index) => {
    gsap.to(item, {
      opacity: 1,
      y: 0,
      duration: 1,
      delay: index * 0.3, // Stagger the animation
      scrollTrigger: {
        trigger: item,
        start: "top 80%", // When the item enters the viewport
        end: "top 50%", // When it's halfway visible
        toggleActions: "play none none reverse", // Replay when scrolled back
      },
    });
  });
  // useEffect(() => {
  //   const supportPoints = document.querySelectorAll(".home_layer6_support_point");

  //   supportPoints.forEach((point, index) => {
  //     const timeline = gsap.timeline({
  //       scrollTrigger: {
  //         trigger: point,
  //         start: "top 80%", // Animation starts when the element is 80% in view
  //         end: "top 50%", // Ends when it reaches the 50% viewport
  //         scrub: true,
  //       },
  //     });

  //     timeline
  //       .from(point, {
  //         y: -50, // Start above the viewport
  //         opacity: 0, // Start invisible
  //         duration: 0.5,
  //         ease: "power2.out",
  //       })
  //       .from(
  //         point.querySelector(".home_layer6_circle_indicator"),
  //         {
  //           scale: 0, // Start as a dot
  //           duration: 0.3,
  //           ease: "back.out(1.7)",
  //         },
  //       );
  //   });
  // }, []);
  return (
    <div class="animated-list">
      <div class="list-item">
        <div class="dot"></div>
        <div class="line"></div>
        <p>
          Lorem Ipsum is simply dummy text of the printing and typesetting
          industry.
        </p>
      </div>
      <div class="list-item">
        <div class="dot"></div>
        <div class="line"></div>
        <p>
          Lorem Ipsum has been the industry's standard dummy text ever since the
          1500s.
        </p>
      </div>
      <div class="list-item">
        <div class="dot"></div>
        <div class="line"></div>
        <p>
          When an unknown printer took a galley of type and scrambled it to make
          a type specimen book.
        </p>
      </div>
    </div>
    // <div className="home_layer6_support_details">
    //   <div className="home_layer6_dotted_line"></div>
    //   <p className="home_layer6_support_point">
    //     <span className="home_layer6_circle_indicator"></span>
    //     Lorem Ipsum is simply dummy text of the printing and typesetting Lorem
    //     Ipsum is simply dummy
    //   </p>
    //   <p className="home_layer6_support_point">
    //     <span className="home_layer6_circle_indicator"></span>
    //     Lorem Ipsum is simply dummy text of the printing and typesetting Lorem
    //     Ipsum is simply dummy
    //   </p>
    //   <p className="home_layer6_support_point">
    //     <span className="home_layer6_circle_indicator"></span>
    //     Lorem Ipsum is simply dummy text of the printing and typesetting Lorem
    //     Ipsum is simply dummy
    //   </p>
    // </div>
  );
};

export default TypingText;
